import moment from 'moment-timezone';

export class EnterpriseBudgetSchedule {
	public currentCycleStartDate: Date;
	public currentCycleEndDate: Date;
	public nextCycleStartDate: Date;
	public nextCycleEndDate: Date;
	public nextCycleGenerationDate: Date;

	constructor(enterpriseBudgetSchedule?: Subset<EnterpriseBudgetSchedule>) {
		Object.assign(this, enterpriseBudgetSchedule);

		this.currentCycleStartDate = this.currentCycleStartDate
			? new Date(moment(this.currentCycleStartDate).format('MMM DD, YYYY hh:mm:ss a'))
			: this.currentCycleStartDate;
		this.currentCycleEndDate = this.currentCycleEndDate
			? new Date(moment(this.currentCycleEndDate).format('MMM DD, YYYY hh:mm:ss a'))
			: this.currentCycleEndDate;
		this.nextCycleStartDate = this.nextCycleStartDate
			? new Date(moment(this.nextCycleStartDate).format('MMM DD, YYYY hh:mm:ss a'))
			: this.nextCycleStartDate;
		this.nextCycleEndDate = this.nextCycleEndDate ? new Date(moment(this.nextCycleEndDate).format('MMM DD, YYYY hh:mm:ss a')) : this.nextCycleEndDate;
		this.nextCycleGenerationDate = this.nextCycleGenerationDate
			? new Date(moment(this.nextCycleGenerationDate).format('MMM DD, YYYY hh:mm:ss a'))
			: this.nextCycleGenerationDate;
	}
}
